import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/scss/main.scss";

/* Config ParticlesJs */
import Particles from "particles.vue3";

/* Config Modal  */
import "vue-universal-modal/dist/index.css";

import VueUniversalModal from "vue-universal-modal";

/* Create Vue App Instance */
createApp(App)
  .use(Particles)
  .use(store)
  .use(VueUniversalModal, {
    teleportTarget: "#modal",
    modalComponent: "ModalComponent",
  })
  .use(router)
  .mount("#app");
